export const PRIMARY_PICTURE = 'PRIMARY_PICTURE';
export const SECONDARY_PICTURE = 'SECONDARY_PICTURE';

export const STORE_PICTURE = 'STORE';
export const PICTURE = 'PICTURE';
